import { render } from "./PowerItem.vue?vue&type=template&id=602aec0e&scoped=true"
import script from "./PowerItem.vue?vue&type=script&lang=js"
export * from "./PowerItem.vue?vue&type=script&lang=js"

import "./PowerItem.vue?vue&type=style&index=0&id=602aec0e&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602aec0e"]])

export default __exports__